module.exports = __webpack_public_path__ + "static/media/mama-faktura.45b09cc9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/exhibitors/mama-faktura.jpeg
// module id = 456
// module chunks = 0